import { ELMENT_REF_LIST_PROP_KEY, ELMENT_REF_PROP_KEY } from "../../templateBuilder/enum";

const byPassProps = new Set([ELMENT_REF_PROP_KEY, ELMENT_REF_LIST_PROP_KEY])

const isAvoidEmitCase = key => {
    return typeof key === 'symbol' && !byPassProps.has(key);
}

export default isAvoidEmitCase